<div *ngIf="!currentUser">

  <!-- Region content -->
  <div class="section-region-love" *ngIf="!neighborhood && content[region.slug]">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 style="font-size: 18px">{{ content[region.slug].title }}</h1>
          <p *ngFor="let detail of content[region.slug].details">{{ detail }}</p>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <!-- Neighborhood: Love -->
  <div class="section-neighborhood-love" *ngIf="neighborhood && contentOld[region.slug] && (contentOld[region.slug]?.neighborhoods)[neighborhood.slug] && (contentOld[region.slug]?.neighborhoods)[neighborhood.slug]?.love">
    <div class="container">
      <div class="row">
        <div class="col">
          <h4>What we love about {{ neighborhood.name }}:</h4>
          <p>{{ contentOld[region.slug].neighborhoods[neighborhood.slug].love }}</p>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <!-- Neighborhood: About -->
  <div class="section-neighborhood-about" *ngIf="neighborhood && contentOld[region.slug] && (contentOld[region.slug]?.neighborhoods)[neighborhood.slug] && (contentOld[region.slug]?.neighborhoods)[neighborhood.slug]?.about">
    <div class="container">
      <div class="row">
        <div class="col">
          <h4>Find the perfect coworking space in {{ neighborhood.name }}:</h4>
          <p>{{ contentOld[region.slug].neighborhoods[neighborhood.slug].about }}</p>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <!-- Neighborhood: Travel -->
  <div class="section-neighborhood-travel" *ngIf="neighborhood && contentOld[region.slug] && (contentOld[region.slug]?.neighborhoods)[neighborhood.slug] && (contentOld[region.slug]?.neighborhoods)[neighborhood.slug]?.travel">
    <div class="container">
      <div class="row">
        <div class="col">
          <h4>Getting to {{ neighborhood.name }}:</h4>
          <p>{{ contentOld[region.slug].neighborhoods[neighborhood.slug].travel }}</p>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <!-- Neighborhood: Links -->
  <div class="section-neighborhood-links" *ngIf="neighborhoods.length > 1">
    <div class="container">
      <div class="row">
        <div class="col">
          <h4>Find a space nearby in these <a class="hover-link" [routerLink]="['/discover', region.slug]">{{ region.name }}</a> neighborhoods:</h4>
          <p class="neighborhoods-section">
            <span *ngFor="let neighborhood of neighborhoods; let pos = index">
              <span *ngIf="pos > 0"> • </span>
              <a class="hover-link" [routerLink]="['/discover', region.slug, neighborhood.slug]">{{ neighborhood.name }}</a>
            </span>
          </p>
          <br/>
        </div>
      </div>
    </div>
  </div>

</div>
